import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MUI
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";

// MUI Icons
import CloseIcon from "@mui/icons-material/Close";

// Custom Components
import { GridContainer } from "@/ui/Grid";
import SnackbarContext from "@/ui/SnackbarContext/SnackbarContext";
import FormContent from "@/components/FormContent";
import FormButton from "@/ui/Form/FormButton";
import useAuthFormController from "@/components/useAuthFormController";

// Types
import { PasswordResetRequestFormProps } from "@/@types/views/Auth";

function PasswordResetRequestForm(props: PasswordResetRequestFormProps) {
  const { t } = useTranslation();
  const snackbarContext = useContext(SnackbarContext);

  const navigate = useNavigate();

  const { onCompleted, form, dc } = props;
  const { record, validation, fields, onFieldChange, doSendPasswordResetRequest } = useAuthFormController(props);

  const handleSubmit = () => {
    if (doSendPasswordResetRequest) {
      doSendPasswordResetRequest()
        .then((result) => {
          if (result.success) {
            if (onCompleted) {
              onCompleted({ success: true });
            }
            if (snackbarContext) {
              snackbarContext.showNotification(t("notifications.succesful"), "success");
            }
          }
        })
        .catch((result) => {
          if (result.validationPass === false) {
            if (snackbarContext) {
              snackbarContext.showNotification(result.validation as string, "error");
            }
          } else {
            if (onCompleted) {
              onCompleted({ success: false });
            }
            if (snackbarContext) {
              snackbarContext.showNotification(t("notifications.unsuccesful"), "error");
            }
          }
        });
    }
  };

  const handleCancel = () => {
    navigate("/login");
  };

  const backHome = () => {
    navigate("/");
  };

  return (
    <Card>
      <CardHeader
        title={t("titles.password_reset_request")}
        action={
          <IconButton onClick={backHome}>
            <CloseIcon />
          </IconButton>
        }
      />
      <CardContent>
        <GridContainer>
          <FormContent
            fieldNames={dc.getFormFieldsNames(form)}
            record={record}
            validation={validation}
            fields={fields}
            onFieldChange={onFieldChange}
            onSubmit={() => handleSubmit()}
            mode="insert"
            columns={1}
          />
        </GridContainer>
      </CardContent>
      <CardActions sx={{flexDirection: {xs: "column", md: "row"}, rowGap: 1}}>
        <FormButton variant="contained" onClick={handleSubmit} sx={{mx: 1, width: {xs: "100%", md: "auto"}}}>
          {t("buttons.send")}
        </FormButton>
        <FormButton variant="text" onClick={handleCancel} sx={{mx: 1, width: {xs: "100%", md: "auto"}}}>
          {t("buttons.cancel")}
        </FormButton>
      </CardActions>
    </Card>
  );
}

export default PasswordResetRequestForm;
